import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { RelocationProcessApiAdapter } from '../adapters/RelocationProcessApiAdapter';

const LOCATION_QUERY_KEY = 'relocation-process-locations';

/**
 * Resuelve ubicaciones por IDs para mostrar código de origen en las líneas.
 * Usa GET /api/v1/locations?ids=1,2,3
 */
export const useLocationDetails = (locationIds: number[]) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new RelocationProcessApiAdapter(httpClient), [httpClient]);

  const uniqueIds = useMemo(() => {
    return Array.from(new Set(locationIds.filter((id) => Number.isInteger(id) && id > 0)));
  }, [locationIds]);

  const { data, isLoading } = useQuery({
    queryKey: [LOCATION_QUERY_KEY, uniqueIds],
    queryFn: () => adapter.getLocationsByIds(uniqueIds),
    enabled: uniqueIds.length > 0,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const locationsById = useMemo(() => {
    const map = new Map<number, { id: number; code: string }>();
    (data || []).forEach((location) => map.set(location.id, location));
    return map;
  }, [data]);

  return { locationsById, isLoading };
};
